import React from 'react'
import PropTypes from 'prop-types'
import MutationManager from './Mutation'
import gql from 'graphql-tag'

/**
 * [CLEAN_ORDER] Example Input
 * {
  "orderId": "123456"
 */

const CLEAN_ORDER = gql`mutation cleanOrder($orderId: String, $user: String, $phone: String, $salesChannel: String){
  cleanOrder(orderId: $orderId, user: $user, phone: $phone, salesChannel: $salesChannel) {
    status
    message
  }
}
`
const UpdatePickers = ({ children, ...props }) => {
  return (
    <MutationManager mutation={CLEAN_ORDER} refetchQueries={['getOrderById', 'getOrderItems', 'getPickingInfoBy', 'getAssignmentInfo']}>
      {({ data, loading, updateFn }) => children({ updateFn, loading, data })}
    </MutationManager>
  )
}

UpdatePickers.propTypes = {
  children: PropTypes.any
}

export default UpdatePickers
